import React from 'react';
import {Loader, LoaderContainer} from './styles';

export default ({height = 'auto', width = 'auto', color = '#5d6c76'} : {height?: string; width?: string; color?: string}) => (
  <LoaderContainer height={height} width={width}>
    <Loader color={color} />
  </LoaderContainer>
);
